import { lazy } from 'react';

export const ToolPageLazy = lazy(() => import('./ToolPage'));
